const getTime = (dateObject: string): string => {
  let hours, minutes;
  const date = new Date(dateObject);

  hours = date.getHours();
  minutes = date.getMinutes();

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;

  const time = hours + ':' + minutes;
  return time;
};

const getTimeAmPm = (dateObject: string): string => {
  const date = new Date(dateObject);

  let hours = date.getHours();
  let minutes = date.getMinutes();

  // Determine AM or PM
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert hours to 12-hour format
  hours = hours % 12 || 12; // '0' should be '12'

  // Format hours and minutes with leading zeros
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  // Return formatted time
  return `${formattedHours}:${formattedMinutes}${ampm}`;
};

const getTimeWithoutTZ = (time: string): string => {
  try {
    return time.split('T')[1].split('.')[0].substring(0, 5);
  } catch (error) {
    // fallback to old method
    return getTime(time);
  }
};

const formatDate = (dateObject: string): string => {
  const date = new Date(dateObject);
  const year =
    date.getMonth() +
    1 +
    '/' +
    date.getDate() +
    '/' +
    date.getFullYear().toString().substr(-2);
  return year;
};

const formatDateWithoutTZ = (dateObject: string): string => {
  const date = dateObject.split('-');
  return `${date[1]}/${date[2]}/${date[0].substr(-2)}`;
};

const formatDateWithYearWithoutTZ = (dateObject: string): string => {
  const date = dateObject.split('-');
  return `${date[1]}/${date[2]}/${date[0]}`;
};

const formatDateMDY = (dateObject: string): string => {
  const date = new Date(dateObject);
  const year =
    date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
  return year;
};

const isFuture = (dateObject: string): boolean => {
  // checks assigned case whether future or past
  if (
    new Date(dateObject).getFullYear() > new Date().getFullYear() ||
    (new Date(dateObject).getFullYear() === new Date().getFullYear() &&
      new Date(dateObject).getMonth() > new Date().getMonth()) ||
    (new Date(dateObject).getFullYear() === new Date().getFullYear() &&
      new Date(dateObject).getMonth() === new Date().getMonth() &&
      new Date(dateObject).getDate() > new Date().getDate())
  ) {
    return true;
  } else {
    return false;
  }
};

const formatDateDMY = (dateObject: string): string => {
  const date = new Date(dateObject);
  const year =
    date.getMonth() + 1 + '-' + date.getDate() + '-' + date.getFullYear();
  return year;
};

const formatDateDMYWithSlashes = (dateObject: string): string => {
  const date = new Date(dateObject);
  const year =
    date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
  return year;
};

const formatDateDMYWithSlashesAndZeros = (
  dateObject: string,
  needTime?: boolean
): any => {
  const date: any = new Date(dateObject);
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  const year: any = date.getFullYear();

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  let dateObj: any = month + '/' + day + '/' + year;

  if (needTime)
    dateObj =
      dateObj +
      ' . ' +
      date.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

  return dateObj;
};

const formatDateDMYHM = (dateObject: any): string => {
  let hours, minutes;

  const date = new Date(dateObject);
  hours = date.getHours();
  minutes = date.getMinutes();

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;

  const dateAndtime =
    date.getDate() +
    '/' +
    (date.getMonth() + 1) +
    '/' +
    date.getFullYear().toString().substr(-2) +
    ' . ' +
    hours +
    ':' +
    minutes;
  return dateAndtime;
};

const isAssignedCase = (dateObject: string): boolean => {
  // checks whether case is assigned to me or case still open
  if (
    new Date(dateObject).getFullYear() < new Date().getFullYear() ||
    new Date(dateObject).getMonth() < new Date().getMonth() ||
    new Date(dateObject).getDate() < new Date().getDate()
  ) {
    return false;
  } else {
    return true;
  }
};

const isToday = (dateObject: string): boolean => {
  // checks whether case is today or not
  const date = dateObject.split('-'),
    currentDate = new Date();
  if (
    parseInt(date[0]) === currentDate.getFullYear() &&
    parseInt(date[1]) - 1 === currentDate.getMonth() &&
    parseInt(date[2]) === currentDate.getDate()
  ) {
    return true;
  } else {
    return false;
  }
};

const compare = (firstItem: any, secondItem: any): number => {
  if (
    new Date(firstItem.time_of_surgery).getFullYear() ==
      new Date(secondItem.time_of_surgery).getFullYear() &&
    new Date(firstItem.time_of_surgery).getMonth() ==
      new Date(secondItem.time_of_surgery).getMonth() &&
    new Date(firstItem.time_of_surgery).getDate() ==
      new Date(secondItem.time_of_surgery).getDate()
  ) {
    if (
      new Date(firstItem.time_of_surgery).getHours() <
        new Date(secondItem.time_of_surgery).getHours() ||
      new Date(firstItem.time_of_surgery).getMinutes() <
        new Date(secondItem.time_of_surgery).getMinutes() ||
      new Date(firstItem.time_of_surgery).getSeconds() <
        new Date(secondItem.time_of_surgery).getSeconds()
    ) {
      return -1;
    } else {
      return 1;
    }
  } else if (
    new Date(firstItem.time_of_surgery).getFullYear() <
      new Date(secondItem.time_of_surgery).getFullYear() ||
    new Date(firstItem.time_of_surgery).getMonth() <
      new Date(secondItem.time_of_surgery).getMonth() ||
    new Date(firstItem.time_of_surgery).getDate() <
      new Date(secondItem.time_of_surgery).getDate()
  ) {
    return -1;
  } else {
    return 1;
  }
};

const formatDateMDYHM = (dateObject: any): string => {
  let hours, minutes;

  const date = new Date(dateObject);
  hours = date.getHours();
  minutes = date.getMinutes();

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;
  const dateAndtime =
    date.getMonth() +
    1 +
    '/' +
    date.getDate() +
    '/' +
    date.getFullYear().toString().substr(-2) +
    ' . ' +
    hours +
    ':' +
    minutes;

  return dateAndtime;
};

const formatDateMMDD = (dateObject: string): string => {
  const dateObj = new Date(dateObject);
  let dd;
  let mm;
  if (isNaN(dateObj.getDate())) {
    return '';
  } else {
    dd = dateObj.getDate();
  }
  if (isNaN(dateObj.getMonth())) {
    return '';
  } else {
    mm = dateObj.getMonth() + 1;
  }
  const date = ' ' + mm + '/' + dd;
  return date;
};

const formatDateHHMM = (dateObject: string): string => {
  const dateObj = new Date(dateObject);
  let hours: any = dateObj.getHours();
  let minutes: any = dateObj.getMinutes();

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;

  return hours + ':' + minutes;
};

const transformDate = (timestamp: any): string => {
  // If it's already in the format "09/26/23", return it directly
  if (/^\d{2}\/\d{2}\/\d{2}$/.test(timestamp)) {
    return timestamp;
  }

  const parts = timestamp?.split('T');
  const datePart = parts[0];
  const yearPart = parts[1].split('/')[1];

  // Add a null check before using split
  return (datePart && yearPart) ? `${datePart}/${yearPart}` : '';
};

export default {
  getTime,
  getTimeAmPm,
  getTimeWithoutTZ,
  formatDate,
  formatDateWithoutTZ,
  isFuture,
  isAssignedCase,
  isToday,
  compare,
  formatDateMDY,
  formatDateDMY,
  formatDateDMYHM,
  formatDateMDYHM,
  formatDateDMYWithSlashes,
  formatDateDMYWithSlashesAndZeros,
  formatDateWithYearWithoutTZ,
  formatDateMMDD,
  formatDateHHMM,
  transformDate
};
